import { UpdateInventoryProductStockRequest } from '@/api/inventoryProductsStocks/request.types.ts'
import { UpdateInventoryProductStockResponse } from '@/api/inventoryProductsStocks/response.types.ts'
import {
  useInventoryProductsStocksApiClient,
} from '@/api/inventoryProductsStocks/useInventoryProductsStocksApiClient.ts'
import { useCreateItem } from '@/presentation/common/hooks/crud/v2/useCreateItem.ts'

export const useDecreaseInventoryStocks = () => {
  const repository = useInventoryProductsStocksApiClient()
  const createItem = useCreateItem<UpdateInventoryProductStockRequest, UpdateInventoryProductStockResponse>({
    callable : repository.decrease,
    messages : {
      default : 'No se pudo reducir el stock',
      success : 'Stock reducido con éxito',
      loading : 'Reduciendo stock',
    },
  })

  return {
    ...createItem,
  }
}
